import React from 'react';
import { Button, Modal, Form, notification } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { compose as recompose, withHandlers, withProps} from 'recompose';
import { Field, reduxForm } from 'redux-form';
import { required  } from '../../../helpers/validate';
import { FieldInput, FieldTextArea, FieldCheckBox } from '../../../components/Fields';
import { DEPARTMENT_FORM_KEY, DEPARTMENTFormAction } from '../../../reduxs/department-redux/action';

const DepartmentForm = (props) => {
  const { open, close, reset, handleSubmit, submitting, pristine } = props;
  const submit = handleSubmit(DEPARTMENTFormAction);

  return (
    <Modal
      title='Thêm mới'
      visible={open}
      style={{ top: 50 }}
      width={'760px'}
      footer={null}
      maskClosable={false}
      onOk={() => { reset(); close(false) }}
      onCancel={() => { reset(); close(false) }}
      className="modal-form-menu"
    >
      <Form layout="vertical" onFinish={submit}>
        <div className="row">
          <div className="col-md-6">
            <Field
              component={FieldInput}
              label="Tên phòng ban"
              name="Name"
              placeholder="Tên phòng ban"
              className="required"
              validate={[required]}
            />
          </div>
          <div className="col-md-6">
            <Field
              component={FieldInput}
              label="Mã phòng ban"
              name="Code"
              placeholder="Mã phòng ban"
              className="required"
              validate={[required]}
            />
          </div>
          <div className="col-md-6">
            <Field
              component={FieldTextArea}
              label="Mô tả"
              name="Description"
              placeholder="Mô tả"
              rows={2}
            />
          </div>
          <div className="col-md-6">
            <Field
              component={FieldCheckBox}
              label="Trạng thái"
              text="Trạng thái"
              name="IsActive"
            />
          </div>
          <div className="col-md-12">
            <Field
              component={FieldTextArea}
              label="Ghi chú"
              name="Remark"
              placeholder="Ghi chú"
              rows={2}
            />
          </div>
        </div>
        <Form.Item className="text-center">
            <Button loading={submitting} disabled={pristine} type="primary" icon={<SaveOutlined />} htmlType="submit">Lưu</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default recompose(
    withProps(({department}) => {
        if(department) {
          return { initialValues: { ...department }};
        } else {
          return { initialValues: null};
        }
      }
    ),
    withHandlers({
    }),
    reduxForm({
      form: DEPARTMENT_FORM_KEY,
      enableReinitialize: true,
      onSubmitSuccess: (result, dispatch, props) => {
          notification.success({
              message: 'Lưu thành công!'
          });
          props.initialValues = null;
          props.reset();
          props.close(false);
          props.fetchDepartments();
      }
    })
)(DepartmentForm);
